`ifndef DISABLE_PROTOCOL_CHECKER_HARNESS_NOT_BOUND_WARNINGS
  if ({{ handle.identifier }} == 0) begin
    `uvm_warning(get_type_name(), "Without a protocol checker bound, protocol violations can not be detected. Turn off this message, and others like it, by defining `DISABLE_PROTOCOL_CHECKER_HARNESS_NOT_BOUND_WARNINGS.")
  end
`endif
